import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCloudOff12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconCloudOff12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M10.225 1.082a.5.5 0 0 1 .693.693l-.064.078-.837.836a3.65 3.65 0 0 1 1.035 2.997c.58.486.948 1.2.948 1.997 0 1.464-1.24 2.65-2.77 2.65H2.77a3 3 0 0 1-.373-.025l-1.043 1.045a.5.5 0 1 1-.708-.707l9.5-9.5zm-6.851 8.25H9.23c1.02 0 1.77-.779 1.77-1.649 0-.479-.22-.92-.59-1.23l-.416-.347.065-.539q.018-.154.018-.313c0-.705-.288-1.362-.768-1.857zM7.154 1.5q.569.001 1.09.147l-.863.863q-.112-.009-.227-.01c-.744 0-1.418.261-1.93.685l-.343.285-.443-.066a2 2 0 0 0-.284-.02c-1.019 0-1.769.779-1.77 1.649q0 .106.014.209l.093.683-.607.33C1.339 6.549 1 7.09 1 7.683c0 .33.108.645.297.911l-.65.652-.057.068A2.57 2.57 0 0 1 0 7.684c0-.99.567-1.854 1.407-2.31a3 3 0 0 1-.022-.341c0-1.464 1.24-2.65 2.77-2.65q.22 0 .432.032A4 4 0 0 1 7.154 1.5"
            />
        </svg>
    );
}
export default memo(IconCloudOff12);
